export const logDev = (...args: any[]) => {
  if (import.meta.env.MODE !== "production") {
    const [message, ...extra] = args;

    if (message instanceof DOMException) {
      console.error(message);
    } else if (typeof message === "string") {
      console.log(`(dev) ${message}`, ...extra);
    } else {
      console.log("(dev)", message, ...extra);
    }
  }
};
